<style scoped>
.date-row {
	display: flex;
	gap: 1rem;
	align-items: flex-end;
	margin-bottom: 1rem;
	flex-wrap: wrap;
}

.date-field {
	flex: 0 0 auto;
}

.date-field label {
	display: block;
	margin-bottom: 0.375rem;
	font-size: 0.875rem;
	font-weight: 600;
	color: #4a5568;
}

.date-field input[type="date"] {
	padding: 0.5rem 0.75rem;
	border: 1px solid #cbd5e0;
	border-radius: 6px;
	font-size: 0.9rem;
	background: white;
	min-width: 180px;
}

.date-field input[type="date"]:focus {
	outline: none;
	border-color: #4299e1;
	box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.15);
}
</style>

<template>
	<div>
		<h5 class="mb-3">
			<i class="bi bi-cloud-upload me-2"></i>Upload Pool Data
		</h5>

		<p class="text-muted mb-4">
			Upload a CSV file containing pool information from ABC Data Analytics
			services.
		</p>

		<CSVUpload
			:uploadUrl="'/api/upload/pool/flyover'"
			:additionalData="{ date: selectedDate }"
			@doSuccess="handleSuccess"
			@doError="handleError"
		/>
	</div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useRouter } from "vue-router";
import CSVUpload from "@/components/CSVUpload.vue";

const router = useRouter();

const today = new Date();
const selectedDate = ref(
	`${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`,
);

function handleSuccess(path: string) {
	router.push(path);
}

function handleError(error: Error) {
	console.error("Upload failed:", error);
}
</script>
